import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  KsfCoverage,
  UpdateKsfTemplate,
} from 'projects/shared/src/lib/models/ksf.model';
import {
  DmrResponse,
  ResetPriceCalculator,
} from 'projects/shared/src/public-api';

@Component({
  selector: 'lib-ksf-coverage-selection',
  templateUrl: './ksf-coverage-selection.component.html',
  styleUrls: ['./ksf-coverage-selection.component.scss'],
  standalone: false,
})
export class KsfCoverageSelectionComponent {
  // Event emitted to the parent component
  @Output() nextStepEvent = new EventEmitter();
  @Output() setKsfTemplateEvent = new EventEmitter<UpdateKsfTemplate>();
  @Output() recalculateKsfPricesEvent = new EventEmitter();
  @Output() setChargingStandEvent = new EventEmitter<boolean>();

  // Input properties to receive data from the parent component
  @Input() ksfCoverages: KsfCoverage[] = [];
  @Input() allHaveToggleChargingStandAllowed: boolean = false;
  @Input() vehicleFromDmr: DmrResponse = {} as DmrResponse;
  @Input() ksfTemplate: UpdateKsfTemplate = {} as UpdateKsfTemplate;
  @Input() chargingStand: boolean = false;
  @Input() showYearlyPrice: boolean = false;
  @Input() textDirectedToCustomer: boolean = false;

  // Internal state variables
  tooltipVisibility: boolean[] = [];

  constructor(public resetPriceCalculator: ResetPriceCalculator) {
    // Subscribe to reset events
    this.resetPriceCalculator.resetPriceCalculatorValues.subscribe(() => {
      this.resetKsfInfo();
    });

    this.resetPriceCalculator.resetKsfValues.subscribe(() => {
      this.resetKsfInfo();
    });
  }

  /**
   * Reset the info
   * @returns void
   */
  resetKsfInfo(): void {
    this.tooltipVisibility = [];
  }

  /**
   * Toggles the visibility of a tooltip based on the given index and state.
   * @param index - The index of the tooltip to toggle.
   * @param state - The desired visibility state (true for visible, false for hidden).
   * @returns void
   */
  toggleTooltip(index: number, state: boolean): void {
    this.tooltipVisibility[index] = state;
  }

  /**
   * Toggles the coverage for the charging stand and emits an event with the updated state.
   * @returns void
   */
  toggleChargingStandCoverage(): void {
    this.chargingStand = !this.chargingStand;
    this.setChargingStandEvent.emit(this.chargingStand);
  }

  /**
   * Emit event to move to the next step
   * @returns void
   */
  nextStep(): void {
    this.nextStepEvent.emit();
  }

  /**
   * Toggles the selection state of a cover based on the provided index and emits relevant events.
   * @param index - The index of the cover to toggle.
   * @returns void
   */
  setSelectedCovers(index: number): void {
    // Check if the cover at the given index is not selected
    if (!this.ksfTemplate.covers[index].Selected) {
      // If not selected, set it to selected
      this.ksfTemplate.covers[index].Selected = true;
    } else {
      // If already selected, set it to not selected
      this.ksfTemplate.covers[index].Selected = false;
    }

    this.setKsfTemplateEvent.emit(this.ksfTemplate);
    this.recalculateKsfPricesEvent.emit();
  }
}
